<div class="inline-flex flex-middle b-a b-col-42"
     [ngClass]="{'p-t-1 p-b-1': bigVariant, 'm-l-6 m-r-6': isParent}"
     [class.is-busy]="status?.busy">
    @if (!isParent) {
    <button class="center col-43"
            [class.is-disabled]="!canLess() || status?.busy"
            [attr.aria-label]="'Remove one item' | translate"
            [attr.sl-basket-item-button-qty-less]="custom ? custom.id : null"
            (click)="less()"
            cy-decreaseQty>
        <i class="icon-minus fs-2 "
           aria-hidden="true"></i>
    </button>
    }

    <input class="no-spinner center"
           [class]="bigVariant ? 'p1' : 'p2'"
           style="letter-spacing: 0;"
           type="number"
           step="1"
           [disabled]="status?.busy || (!canMore() && !canLess()) "
           [attr.min]="min ? min : null"
           [attr.sl-basket-item-qty-input]="itemId || null"
           cy-qtyInput
           #input
           [(ngModel)]="model"
           (blur)="validate()"
           [minWidth]="inputWidth"
           autoSizeInput>

    @if (!isParent) {
    <button class="center col-43"
            [class.is-disabled]="!canMore() || status?.busy"
            [attr.aria-label]="'Add one item' | translate"
            [attr.sl-basket-item-button-qty-more]="custom ? custom.id : null"
            (click)="more()"
            cy-increaseQty>
        <i class="icon-plus fs-2"
           aria-hidden="true"></i>
    </button>
    }

    @if (status?.busy) {
    <div class="fill flex flex-middle flex-justify-center b-radius-4 busy-icon">
        <i class="icon-loading"></i>
    </div>
    }
</div>